import { combineReducers, Reducer } from 'redux';
import { History } from 'history';
import { connectRouter, RouterState } from 'connected-react-router';
import { requestsReducer } from './reduxRequests';
import { RequestsStore } from '@redux-requests/core';
import appReducer, { IAppState } from 'modules/app/store/reducer';
import layoutReducer, { ILayoutState } from 'modules/layout/store/reducer';

const rootReducer = (history: History): Reducer =>
  combineReducers({
    router: connectRouter(history),
    requests: requestsReducer,
    app: appReducer,
    layout: layoutReducer,
  });

export interface RootState {
  router: RouterState;
  requests: RequestsStore;
  app: IAppState;
  layout: ILayoutState;
}

export default rootReducer;
